function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n    position: absolute;\n    right: 16px;\n    top: 16px;\n    z-index: 9999;\n    overflow: hidden !important;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { createPortal } from 'react-dom';
import styled from 'styled-components';
import { useTransition } from '@react-spring/web';
import Notification from './Notification';
var Wrapper = styled.div(_templateObject());
var NotificationContainer = function NotificationContainer(param) {
    var notifications = param.notifications;
    var transitions = useTransition(notifications, {
        keys: function keys(notification) {
            return notification.id;
        },
        from: {
            right: '-100%'
        },
        enter: {
            right: '0%'
        },
        leave: {
            right: '-100%'
        }
    });
    return /*#__PURE__*/ createPortal(/*#__PURE__*/ _jsx(Wrapper, {
        children: transitions(function(style, item) {
            return /*#__PURE__*/ _jsx(Notification, {
                id: item.id,
                style: style,
                className: item.type,
                children: item.content
            }, item.id);
        })
    }), document.body);
};
export default NotificationContainer;
